import Structure from "./Structure";

export default Structure;